import React from 'react';
import ErrorPage from './ErrorPage';

const NotFoundPage = () => (
  <ErrorPage
    code="404"
    eyebrow="Page Not Found"
    title="We couldn't find that page."
    message="The URL you followed may be broken, expired, or never existed. From here you can head back to the homepage or check your dashboard."
    primaryCta={{ label: 'Back to home', to: '/' }}
    secondaryCta={{ label: 'Open dashboard', to: '/dashboard' }}
  />
);

export default NotFoundPage;
